/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { useEffect } from "react";
import { throttle, debounce } from "underscore";
import DeskpadEditor from "../editor/editor";
import React from "react";

import { SIZES } from "../constants";
import { useStoreon } from "storeon/react";

import t from "translations";
import { orderItemId } from "externalData";
import { LinearProgress } from "@material-ui/core";

const isMobile = window.innerWidth < 480;

const getCanvasSize = (activeObject, isMenuOpened) => {
  if (!activeObject) {
    activeObject = {};
  }
  const container = document.querySelector("#deskpad_root").parentElement;
  const offset = isMenuOpened ? SIZES.leftBarOpened : SIZES.leftBar;

  const topbarEl = document.getElementById("tpbr_topbar");
  const topbar = topbarEl ? topbarEl.offsetHeight : 0;

  let subtopBarHeight = 48;
  if (!activeObject.id && window.innerWidth < 480) {
    subtopBarHeight = 0;
  }

  if (isMobile) {
    return {
      width: container.offsetWidth,
      height:
        container.offsetHeight -
        SIZES.topBar -
        subtopBarHeight -
        offset -
        topbar,
    };
  } else {
    return {
      width: container.offsetWidth - offset,
      height: container.offsetHeight - SIZES.topBar - subtopBarHeight - topbar,
    };
  }
};

const Deskpad = (props) => {
  const {
    dispatch,
    isMenuOpened,
    canvas,
    activeObject,
    isAdmin,
    canvasLoading,
    contentType,
  } = useStoreon(
    "activeObject",
    "isMenuOpened",
    "canvas",
    "isAdmin",
    "canvasLoading",
    "contentType"
  );

  // window.addEventListener("beforeunload", function(e) {
  //   if (canvas && canvas.getObjects().filter(o => !o.excludeFromExport)) {
  //     e.preventDefault();
  //     e.returnValue = "";
  //   } else {
  //     delete e["returnValue"];
  //   }
  // });

  useEffect(() => {
    const size = getCanvasSize();
    const can = new DeskpadEditor("c", size.width, size.height).canvas;
    dispatch("canvas/set", can);
    window.addEventListener(
      "resize",
      throttle(() => {
        const size = getCanvasSize(can.getActiveObject());
        can.setWidth(size.width);
        can.setHeight(size.height);
        can.DPE.cutZone.focusCutZone();
      }, 16),
      false
    );

    const objEventThrottled = throttle((e) => {
      const obj = e.target;
      if (obj) {
        if (obj === obj.canvas.getActiveObject()) {
          dispatch("activeObject/set", obj);
        }
      }
    }, 50);

    if (orderItemId) {
      dispatch("orderId/set", orderItemId);
    }
    const preloader = document.querySelector("#dpe-preloader");
    if (preloader) {
      preloader.style.opacity = 0;
      setTimeout(() => {
        preloader.remove();
      }, 400);
      setTimeout(() => {
        const size = getCanvasSize(can.getActiveObject());
        can.setWidth(size.width);
        can.setHeight(size.height);
        can.DPE.cutZone.focusCutZone();
      }, 1500);
    }
    can.on({
      "selection:created": () => {
        const obj = can.getActiveObject();
        dispatch("activeObject/set", obj);
      },
      "selection:updated": () => {
        const obj = can.getActiveObject();
        dispatch("activeObject/set", obj);
      },
      "selection:cleared": () => {
        dispatch("activeObject/remove");
      },
      "object:scaling": objEventThrottled,
    });
    const DPINotificationEvent = debounce((_) => {
      dispatch(
        "notification/warning",
        t.minDPIis + " " + can.settings.minDPI + " DPI"
      );
    }, 600);
    can.on({ "object:scaleLimit": DPINotificationEvent });
  }, [dispatch]);


  useEffect(
    (_) => {
      if (!canvas) return;
      const size = getCanvasSize(canvas.getActiveObject(), isMenuOpened);
      canvas.setWidth(size.width);
      canvas.setHeight(size.height);
      canvas.DPE.cutZone.focusCutZone();
      canvas.fire("canvas:viewport");
    },
    [canvas, isMenuOpened]
  );

  useEffect(
    (_) => {
      if (!canvas) return;
      const size = getCanvasSize(canvas.getActiveObject(), isMenuOpened);
      canvas.setWidth(size.width);
      canvas.setHeight(size.height);
      canvas.fire("canvas:viewport");
    },
    [canvas, activeObject, isMenuOpened]
  );

  const desktopCss = css`
    transform: translateX(
      ${isMenuOpened ? SIZES.leftBarOpened : SIZES.leftBar}px
    );
  `;

  const disabledStyles = { opacity: 0.5, pointerEvents: "none" };

  return (
    <React.Fragment>
      {canvasLoading && (
        <LinearProgress style={{ width: "100%", position: "absolute" }} />
      )}
      <div
        id="dpe-editor"
        css={!isMobile && desktopCss}
        style={canvasLoading ? disabledStyles : {}}
      >
        <canvas id="c" />
      </div>
    </React.Fragment>
  );
};

export default Deskpad;
